<template>
  <div>
    <p class="title is-3-desktop is-4-tablet is-5-mobile">
      Recojos de Materiales {{ this.getClient.name }}
    </p>

    <section style="margin-top: 30px">
      <b-table :data="materiales"
       paginated
       per-page="10"
       :hoverable="true" :mobile-cards="true">
        <template slot-scope="props">
          <b-table-column label="Tipo Material" class="is-size-7">
            {{ props.row.name}}
          </b-table-column>

          <b-table-column label="Cantidad" class="is-size-7">
            {{ props.row.cantidad}}
          </b-table-column>

          <b-table-column label="N° Código Barras" class="is-size-7">
            {{ props.row.code }}
          </b-table-column>

          <b-table-column class="has-text-centered" label="Acciones">
            <b-tooltip label="Solicitar recojo">
              <button @click="addPickup(props.row)" :disabled="existsFileInPickupCar(props.row)" class="button is-info">
                <b-icon icon="export"></b-icon>
              </button>
            </b-tooltip>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
              </p>
              <p>Ninguna Solicitud Registrada.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>

    <div class="columns">
      <div class="column is-6">
        <p class="title is-3-desktop is-4-tablet is-5-mobile">
          Nueva orden de recojo
        </p>
        <button @click="showModalRegisterPickup" :disabled="!(materialesCar.length>0)" class="button is-info">
          Registrar recojo
        </button>
        <b-table :data="materialesCar" :hoverable="true">
          <template slot-scope="props">
            <b-table-column field="name" label="N° Código Barras" width="50">
              {{ props.row.code }}
            </b-table-column>

            <b-table-column label="Acciones" width="50" centered>
              <b-tooltip type="is-dark" label="Eliminar" position="is-left">
                <button
                  @click="deleteItemFromPickupCar(props.index)"
                  class="button is-small"
                >
                  <b-icon
                    type="is-danger"
                    size="is-mediun"
                    icon="delete"
                  ></b-icon>
                </button>
              </b-tooltip>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                </p>
                <p>Ningun archivo agregado.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
      <div class="column is-6">

           <p class="title is-3-desktop is-4-tablet is-5-mobile">
          Ordenes de recojo
        </p>
        <b-table
          :data="pickupList"
          :hoverable="true"
          :opened-detailed="[1]"
          detailed
          detail-key="id"
        >
          <template slot-scope="props">
            <b-table-column field="name" label="Usuario">
              {{ props.row.userName }}
            </b-table-column>

            <b-table-column field="name" label="Estado">
              <b-tag :type="getClassStatusOrder(props.row.status)">{{props.row.status | StatusOrderConvert}}</b-tag>
            </b-table-column>

            <b-table-column field="pickupRegisterDate" label="Registro">
              {{
                new Date(props.row.pickupRegisterDate)
                  | moment("DD-MM-YYYY - h:mm a")
              }}
            </b-table-column>

            <b-table-column label="Acciones" width="50" centered>
              <b-tooltip
                type="is-dark"
                label="Cancelar recojo"
                position="is-left"
              >
                <button
                  @click="cancelarRecojoMaterialesDialog(props.row)"
                  :disabled="!(props.row.status==='req')"
                  class="button is-small"
                >
                  <b-icon
                    type="is-danger"
                    size="is-mediun"
                    icon="cancel"
                  ></b-icon>
                </button>
              </b-tooltip>
            </b-table-column>

          </template>

          <template slot="detail" slot-scope="props">
            <b-field label="Fecha de recojo">
              <p>
                {{
                  new Date(props.row.pickupDate) | moment("DD-MM-YYYY - h:mm a")
                }}
              </p>
            </b-field>

            <b-field label="Dirección de recojo">
              <p>{{ props.row.pickupAddress }}</p>
            </b-field>

            <b-field label="Materiales">
              <b-table
                :data="props.row.materiales"
                :bordered="false"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                :loading="false"
                :mobile-cards="true"
                :sortable="false"
              >
                <template slot-scope="props">
                  <b-table-column>
                    {{ props.row.code }}
                  </b-table-column>
                </template>

                <template slot="empty">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                      </p>
                      <p>No hay Materiales agregados.</p>
                    </div>
                  </section>
                </template>
              </b-table>
            </b-field>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                </p>
                <p>Ninguna orden de recojo registrada.</p>
              </div>
            </section>
          </template>
        </b-table>


      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import RecojoMateriales from "../../src/api/modules/RecojoMateriales";
import Util from "../util";
import CarritoPickupMateriales from "./CarritoPickupMateriales";


export default {
  data() {
    return {
      materiales: [],
      materialesCar:[],
      pickupList:[],
      pickupList:[]
    };
  },
  methods: {
    cargarPedidos() {
       this.materialesCar=[];
      let idAddress = Util.getUser().idAddress;
      return new Promise((resolve, reject) => {
        RecojoMateriales.getMateriales(this, {
          idClient: this.getClient.id,
          idAddress: idAddress,
        })
          .then((data) => {
            this.materiales = data;
            this.cargarRecojos();
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

     cargarRecojos() {

      let idAddress = Util.getUser().idAddress;
      return new Promise((resolve, reject) => {
        RecojoMateriales.getMaterialesGenerados(this, {
          idClient: this.getClient.id,
          idAddress: idAddress,
        })
          .then((data) => {
            this.pickupList = data;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    addPickup(item) {
      this.$dialog.confirm({
        title: "Solicitar recojo",
        message:
          "Está seguro que desea <b>solicitar recojo</b> del item <b>" +
          item.code +
          "</b>?",
        confirmText: "Si",
        cancelText: "No",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          console.log(item);
          let elemnt= this.materialesCar.filter(a=>a.code==item.code);
          console.log(elemnt);
          if(elemnt.length===0){
              this.materialesCar.push(item);
              this.$toast.open({message:"Material agregado a la solicitud de recojo correctamente",type:"is-success"});
          }


        },
      });
    },

    showModalRegisterPickup() {
      this.$modal.open({
        parent: this,
        component: CarritoPickupMateriales,
        width: 700,
        props: { materiales: this.materialesCar, cargarPedidos: this.cargarPedidos },
      });
    },

    deleteItemFromPickupCar(index){
      this.materialesCar.splice(index,1);

    },

    disabledItem(item){
       let elemnt= this.materialesCar.filter(a=>a.code==item.code);
        if(elemnt.length===0){
        return false;
      }else{
        return true;
      }
    },

    existsFileInPickupCar(item) {
      let busqueda = this.materialesCar.find((obj) => obj.id === item.id);
      if (typeof busqueda === "undefined") {
        return false;
      } else {
        return true;
      }
    },

     cancelarRecojoMaterialesDialog(item) {
      this.$dialog.confirm({
        title: "Cancelar recojo",
        message:
          "Está seguro que desea <b>cancelar el  recojo</b>?",
        confirmText: "Si",
        cancelText: "No",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.cancelarRecojoMateriales(item);
        },
      });
    },


    cancelarRecojoMateriales(item){
      return new Promise((resolve, reject) => {
        RecojoMateriales.getCancelarRecojo(this, {
         idPickup:item.id
        })
          .then((data) => {
            if(data){
              this.cargarPedidos();
            }
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

     getClassStatusOrder(value) {
        if (!value) return ''
        if (value==='req' || value==='envobs' || value==='entobs')
          return 'is-warning'
        else if(value==='apr' || value==='env')
          return 'is-info'
        else if(value==='recep')
          return 'is-success'
        else if(value==='canc')
          return 'is-danger'
        else return ''
      },


  },

  computed: {
    ...mapGetters({
      getClient: "auth/getClient",
    }),




  },
  mounted() {
    this.cargarPedidos();
    this.cargarRecojos()
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RecojoMateriales.vue